import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRecentViewed } from '../utils/recentViewed';
import { FileText } from 'lucide-react';

const RecentViewedFloating = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);

    // 로그인 화면에서는 숨김
    const isLogin = location.pathname.startsWith('/login');
    useEffect(() => {
        if (!open) return;
        setItems(getRecentViewed());
    }, [open, location.pathname]);

    if (isLogin) return null;

    const handleRowClick = (id) => {
        setOpen(false);
        navigate(`/contracts/${id}`);
    };

    return (
        <>
            {/* Floating Button */}
            <button
                aria-label="최근 열람 묘적부"
                onClick={() => setOpen(true)}
                style={{
                    position: 'fixed',
                    right: 20,
                    bottom: 20,
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    backgroundColor: '#ffffff',
                    color: '#fff',
                    boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                    zIndex: 1005,
                    padding: 15,
                    minHeight: 15,
                }}
                className="btn"
            >
                <FileText size={50} className="text-black" />
            </button>

            {/* Modal */}
            {open && (
                <div
                    onClick={() => setOpen(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.3)',
                        zIndex: 1004,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 16,
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: '#fff',
                            borderRadius: 12,
                            width: '100%',
                            maxWidth: 520,
                            maxHeight: '80vh',
                            overflow: 'hidden',
                            boxShadow: '0 12px 32px rgba(0,0,0,0.2)'
                        }}
                    >
                        <div style={{ padding: '16px 16px 0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 18, fontWeight: 700 }}>최근 열람 묘적부</h3>
                            <button className="btn" onClick={() => setOpen(false)}>닫기</button>
                        </div>
                        <div style={{ padding: 16 }}>
                            {items.length === 0 ? (
                                <div className="text-gray-500">최근 열람 내역이 없습니다.</div>
                            ) : (
                                <div className="overflow-x-auto">
                                    <table className="min-w-full">
                                        <thead>
                                            <tr className="text-left text-gray-600">
                                                <th className="py-2 pr-4">묘적번호</th>
                                                <th className="py-2 pr-4">망자명</th>
                                                <th className="py-2 pr-4">열람 일시</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((it) => (
                                                <tr key={`${it.id}-${it.viewedAt}`} className="border-t cursor-pointer hover:bg-gray-50" onClick={() => handleRowClick(it.id)}>
                                                    <td className="py-2 pr-4 font-medium">{it.memberNumber || '-'}</td>
                                                    <td className="py-2 pr-4">{it.deceasedName || '-'}</td>
                                                    <td className="py-2 pr-4">{new Date(it.viewedAt).toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).replace(/\. /g, '/').replace(' ', ' ')}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default RecentViewedFloating;


